import React, { Fragment } from 'react';

import { Form, Col, Button } from 'react-bootstrap';

import { useFieldArray } from 'react-hook-form';

const Fields = ({ control, register, name, initValue, clearError }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  function removeItem(index) {
    clearError(name);
    remove(index);
  }

  return (
    <Fragment>
      {fields.map((field, index) => {
        return (
          <Form.Row key={index} className="mb-2">
            <Col>
              <Form.Control defaultValue={field.value} name={`${name}[${index}]`} type="text" ref={register()} />
            </Col>
            <Col>
              <Button variant="danger" onClick={() => removeItem(index)}>
                <i className="fas fa-times p-0" />
              </Button>
            </Col>
          </Form.Row>
        );
      })}

      <Form.Row>
        <Col>
          <Button variant="info" onClick={() => append(initValue)}>
            <i className="fas fa-plus p-0" />
          </Button>
        </Col>
      </Form.Row>
    </Fragment>
  );
};

export default Fields;
